import { Link } from "react-router-dom";
import { useFadeIn } from "../../hooks/useFadeIn";
import { SectionHeader } from "../layout/SectionHeader";
import { blogs } from "../../data/blogData";

// Format "2023-10-15" → "[oct 2023]"; falls back to "[unknown]" on invalid input.
const fmtDate = (iso: string) => {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "[unknown]";
  return `[${d.toLocaleString("en", { month: "short" }).toLowerCase()} ${d.getFullYear()}]`;
};

export const Logs = () => {
  const ref = useFadeIn<HTMLElement>();
  return (
    <section ref={ref} className="logs reveal" id="logs">
      <div className="container">
        <SectionHeader num="05" command="> tail -f ./logs" caption="recent writing & status" />

        <div className="logs__row">
          <article className="panel">
            <div className="panel__head">{"// "}~/blog</div>
            <ul className="blogList">
              {blogs.map((b) => (
                <li key={b.id}>
                  <Link to="/blogs" className="blogList__link">
                    <div className="blogList__meta">
                      <span>{fmtDate(b.date)}</span>
                      <span className="blogList__time">+4 min</span>
                    </div>
                    <div className="blogList__title">{b.title}</div>
                  </Link>
                </li>
              ))}
            </ul>
          </article>

          <article className="panel">
            <div className="panel__head">{"// "}~/now.txt</div>
            <ul className="nowList">
              <li><span className="plus">+</span> Building a payments dashboard with Stripe + Next.js</li>
              <li><span className="plus">+</span> Reading 'Designing Data-Intensive Applications'</li>
              <li><span className="plus">+</span> Open-sourcing a small Cypress utility library</li>
            </ul>
            <div className="nowList__updated">last updated · 2 days ago</div>
          </article>
        </div>
      </div>
    </section>
  );
};
